import { handleSessionOut } from "../HelperFunctions/HelperFunctions";
import { getToken } from "./tokenStore";

const authApiUrl = process.env.REACT_APP_AUTH_API_URL;
const baseApi8Url = process.env.REACT_APP_BASE_API_8_URL;
const baseApi7Url = process.env.REACT_APP_BASE_API_9_URL;
const paymentLogUrl = process.env.REACT_APP_PAYMENT_LOG;

async function validateToken() {
  const token = getToken();
  let res = await fetch(`${authApiUrl}/v1/OpenApiauth/ValidateToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  let data = await res.json();

  if (data.statusCode !== 200) {
    await handleSessionOut();
    return false;
  }

  return true;
}

export async function exchangeToken(url, authID) {
  let res = await fetch(`${authApiUrl}/${url}/OpenApiauth/ExchangeOAuth`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token: authID }),
  });

  if (res.status === 200) {
    let data = await res.json();
    return data;
  } else if (res.status === 401) {
    await handleSessionOut();
    throw res;
  } else throw res;
}

export async function refreshToken(token, url, refAuthID) {
  const res = await fetch(`${authApiUrl}/${url}/OpenApiauth/RefreshToken`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ refAuthID }),
  });

  const data = await res.json();

  // console.log("dataaaa", data.statusCode || data.StatusCode)

  // if (data?.token && data?.minutesToExpire && data?.refAuth && data.statusCode === 200) {
  if (data.statusCode === 200) {
    return {
      token: data.token,
      minutesToExpire: data.minutesToExpire,
      refAuthID: data.refAuth,
    };
  }
  await handleSessionOut();
  return null;
}

export async function getPrivileges(UID, menuID) {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(`${baseApi7Url}/Previlages`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      RoleID: "000000000000000000000000000000000000",
      UserID: UID,
      MenuIds: menuID,
    }),
  });

  let data = await res.json();
  let privilages = data["Details"];

  return privilages.length > 0 ? privilages[0] : {};
}

export async function getScheduleCategories() {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetScheduledReportMenuInfo`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await res.json();
  // Testing-only: inject Daily Sale Flash Report when menu API did not return it.
  // Keep commented — UI should show only GetScheduledReportMenuInfo schedules.
  // const defaultReport = {
  //   report_id: "010000000000000000000000000000000378",
  //   report: "Daily Sale Flash Report",
  //   date_range: "",
  //   report_type: "",
  //   account: "",
  //   formate_type: "",
  // };
  // data.schedules = [defaultReport, ...data.schedules];
  return data;
}

export async function getSubUserListByUserId() {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetSubUserListByUserId`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  let data = await res.json();
  return data["UserCorporations"];
}

export async function getManagementGroupsList() {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(`${baseApi7Url}/GetManagementGroupsList`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  // return res.json();
  return res;
}

export async function getCorporationsByMgntGrp(MgntGrpId) {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();

  let res = await fetch(
    `${baseApi7Url}/GetCorpsByMgntGrpWithPmsBrandSerTypes?MgntGrpId=${MgntGrpId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res.json();
}

export async function getUserPreferences(UserID) {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(`${baseApi7Url}/UserPreferences`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ UserID }),
  });
  return res.json();
}

export const getCorporations = async (setSelects) => {
  const token = getToken();

  console.log("this is token", token);

  const isValidToken = await validateToken(token);
  console.log("isValidToken", isValidToken);
  if (!isValidToken) return null;

  const response = await fetch(
    `${baseApi7Url}/GetCorporationsByBusinessType?BusinessType=3`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    throw new Error("Failed to fetch corporations");
  }

  const corp = await response.json();
  const corporations = corp.Corporations || [];
  const setSelect = setSelects;
  corporations.unshift(setSelect);
  console.log("corp",corporations)
  return corporations;
};

export const getPCsByCorporation = async (corpId) => {
  const token = getToken();
  const isValidToken = await validateToken(token);
  if (!isValidToken) return null;
  const url = `${baseApi7Url}/GetPCsByBusinessType?CorporationId=${corpId}&BusinessType=3&IsActive=false`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text().catch(() => "");
    throw new Error(`Failed to fetch PCs: ${response.status} ${errorText}`);
  }

  const data = await response.json();
  if (Array.isArray(data?.ListInfo)) {
    const pcsList = data.ListInfo;
    const setSelect = { ID: "select", Name: "-Select-" };
    pcsList.unshift(setSelect);
    return data.ListInfo;
  }
};

export async function LoadRestaurantCorporationList() {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(
    `${baseApi7Url}/LoadRestaurantCorporationList?BussinessType=3`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!res.ok) {
    throw new Error("Failed to load restaurant corporations");
  }
  return res.json();
}


export async function RestGetPortifoliosWithBrands() {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(
    `${baseApi7Url}/RestGetPortifoliosWithBrands`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!res.ok) {
    throw new Error("Failed to load restaurant corporations");
  }
  return res.json();
}


export async function ResCorporationPcsByMgmtGroup( GroupID) {
  const isValidToken = await validateToken();
  if (!isValidToken) return null;

  const token = getToken();
  let res = await fetch(
    `${baseApi7Url}/ResCorporationPcsByMgmtGroupDynamic?GroupID=${encodeURIComponent(GroupID)}`,
    {
      method: "post",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );
  if (!res.ok) {
    throw new Error("Failed to load restaurant corporations");
  }
  return res.json();
}
